const escapeHtml = (value) => {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

const normalizeLine = (value) => {
  if (!value) return '';
  return String(value).replace(/\s+/g, ' ').trim();
};

const buildContactLine = ({ phone, whatsapp }) => {
  const parts = [];
  if (phone) parts.push(phone);
  if (whatsapp) parts.push(`WhatsApp: ${whatsapp}`);
  return parts.join(' | ');
};

export const createEmailSignatureHtml = ({ brand, user, branch, options }) => {
  const accent = brand?.colors?.accent || '#c8a951';
  const logoUrl = normalizeLine(brand?.logoUrl);
  const companyName = normalizeLine(branch?.branchName) || 'Douglas & McCartney';

  const fullName = normalizeLine(user?.fullName);
  const designation = normalizeLine(user?.designation);
  const phone = normalizeLine(user?.phone);
  const whatsapp = options?.showWhatsApp ? normalizeLine(user?.whatsapp) : '';
  const email = normalizeLine(user?.email);

  const addressLine = options?.showAddress ? normalizeLine(branch?.addressLine) : '';
  const website = options?.showWebsite ? normalizeLine(branch?.website) : '';

  const contactLine = buildContactLine({ phone, whatsapp });

  const logoMarkup = logoUrl
    ? `<img src="${escapeHtml(logoUrl)}" alt="Logo" style="display:block; max-height:88px; max-width:180px; width:auto; height:auto;" />`
    : `<div style="font-family: Georgia, 'Times New Roman', serif; font-size: 16px; font-weight: 700; line-height: 1.1; color: #111111;">${escapeHtml(companyName)}</div>`;

  const nameMarkup = fullName
    ? `<div style="font-size: 14px; font-weight: 700; color: #111111;">${escapeHtml(fullName)}</div>`
    : '';

  const designationMarkup = designation
    ? `<div style="font-size: 12px; color: #444444;">${escapeHtml(designation)}</div>`
    : '';

  const contactMarkup = contactLine
    ? `<div style="margin-top: 6px; font-size: 12px; color: #111111;">${escapeHtml(contactLine)}</div>`
    : '';

  const emailMarkup = email
    ? `<div style="margin-top: 4px; font-size: 12px; color: #111111;">${escapeHtml(email)}</div>`
    : '';

  const addressMarkup = addressLine
    ? `<div style="margin-top: 4px; font-size: 11px; color: #555555;">${escapeHtml(addressLine)}</div>`
    : '';

  const websiteMarkup = website
    ? `<div style="margin-top: 2px; font-size: 11px; color: #555555;">${escapeHtml(website)}</div>`
    : '';

  return `
    <table cellpadding="0" cellspacing="0" style="font-family: Arial, Helvetica, sans-serif; color: #111111; line-height: 1.4; border-collapse: collapse;">
      <tr>
        <td style="padding-right: 12px; vertical-align: middle;">
          ${logoMarkup}
        </td>
        <td style="vertical-align: top; padding-left: 12px; border-left: 1px solid ${escapeHtml(accent)};">
          ${nameMarkup}
          ${designationMarkup}
          ${contactMarkup}
          ${emailMarkup}
          ${addressMarkup}
          ${websiteMarkup}
        </td>
      </tr>
    </table>
  `;
};

export const createEmailSignatureText = ({ user, branch, options }) => {
  const fullName = normalizeLine(user?.fullName);
  const designation = normalizeLine(user?.designation);
  const phone = normalizeLine(user?.phone);
  const whatsapp = options?.showWhatsApp ? normalizeLine(user?.whatsapp) : '';
  const email = normalizeLine(user?.email);
  const addressLine = options?.showAddress ? normalizeLine(branch?.addressLine) : '';
  const website = options?.showWebsite ? normalizeLine(branch?.website) : '';

  const lines = [];
  const headerParts = [fullName, designation].filter(Boolean);
  if (headerParts.length) {
    lines.push(headerParts.join(' | '));
  }

  const contactLine = buildContactLine({ phone, whatsapp });
  if (contactLine) {
    lines.push(`Phone: ${contactLine}`);
  }

  if (email) {
    lines.push(`Email: ${email}`);
  }

  if (addressLine) {
    lines.push(`Address: ${addressLine}`);
  }

  if (website) {
    lines.push(`Website: ${website}`);
  }

  return lines.join('\n');
};
